//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import { orderStatusNumApi, orderListApi, orderLogApi, orderMarkApi, orderDeleteApi, orderPrint, orderDetailApi, writeUpdateApi, orderExcelApi, orderPrintReceiptApi, orderReviewApi } from '@/api/order';
import detailsFrom from './components/orderDetail';
import orderSend from './orderSend';
import Cookies from 'js-cookie';
import { isWriteOff } from '@/utils';
import { checkPermi } from '@/utils/permission';
import DirectRefund from '@/views/order/components/directRefund.vue';
import * as $constants from '@/utils/constants';
import { handleDeleteTable } from '@/libs/public'; // 权限判断函数
var tableFroms = {
  status: 'all',
  dateLimit: '',
  orderNo: '',
  page: 1,
  limit: $constants.page.limit[0],
  type: '',
  searchType: 'all',
  content: ''
};
export default {
  name: 'orderlistDetails',
  components: {
    DirectRefund: DirectRefund,
    detailsFrom: detailsFrom,
    orderSend: orderSend
  },
  data: function data() {
    return {
      RefuseVisible: false,
      RefuseData: {},
      orderNo: '',
      refundVisible: false,
      refundData: {},
      dialogVisibleJI: false,
      tableDataLog: {
        data: [],
        total: 0
      },
      tableFromLog: {
        page: 1,
        limit: this.$constants.page.limit[0],
        orderNo: 0
      },
      LogLoading: false,
      isCreate: 1,
      editData: null,
      dialogVisible: false,
      tableData: {
        data: [],
        total: 0
      },
      listLoading: false,
      tableFrom: Object.assign({}, tableFroms),
      orderChartType: {},
      timeVal: [],
      fromList: this.$constants.fromList,
      fromType: [{
        value: '',
        text: '全部'
      }, {
        value: '0',
        text: '普通'
      }, {
        value: '1',
        text: '秒杀'
      }, {
        value: '2',
        text: '拼团'
      }],
      selectionList: [],
      ids: '',
      orderids: '',
      cardLists: [],
      isWriteOff: isWriteOff(),
      proType: 0,
      active: false,
      card_select_show: false,
      checkAll: false,
      checkedCities: ['订单号', '商品信息', '物流信息', '用户昵称', '收货信息', '实际支付', '支付方式', '订单状态', '下单时间'],
      columnData: ['订单号', '商品信息', '物流信息', '用户昵称', '收货信息', '实际支付', '支付方式', '订单状态', '下单时间'],
      isIndeterminate: true,
      orderDatalist: null,
      merPrintStatus: Cookies.get('merPrint'),
      // 商家小票打印开关状态
      dialogVisibleDirectRefund: false,
      secondType: 0,
      //订单二级类型:0-普通订单，1-积分订单，2-虚拟订单，4-视频号订单，5-云盘订单，6-卡密订单
      type: 0,
      //订单类型
      reviewVisible: false,
      // 审核弹窗显示
      reviewForm: {
        orderNo: '',
        // 订单号
        status: 1,
        // 审核状态 1-同意 23-拒绝
        repulseCase: '' // 拒绝原因
      },
      reviewRules: {
        repulseCase: [{
          required: true,
          message: '请输入拒绝原因',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    if (checkPermi(['merchant:order:page:list'])) this.getList();
    if (checkPermi(['merchant:order:status:num'])) this.getOrderStatusNum();
  },
  methods: {
    // 打开审核弹窗
    reviewOrder: function reviewOrder(row) {
      this.reviewForm.orderNo = row.orderNo;
      this.reviewForm.status = 1;
      this.reviewForm.repulseCase = '';
      this.reviewVisible = true;
    },
    // 解析转账凭证图片
    parsePaymentImg: function parsePaymentImg(paymentImg) {
      if (!paymentImg) return [];
      try {
        return JSON.parse(paymentImg);
      } catch (e) {
        return [];
      }
    },
    // 提交审核
    submitReview: function submitReview() {
      var _this = this;
      this.$refs.reviewFormRef.validate(function (valid) {
        if (valid) {
          _this.$modal.loading('审核中...');
          orderReviewApi({
            orderNo: _this.reviewForm.orderNo,
            status: _this.reviewForm.status,
            repulseCase: _this.reviewForm.status == 23 ? _this.reviewForm.repulseCase : ''
          }).then(function (res) {
            _this.$modal.closeLoading();
            _this.$message.success('审核成功');
            _this.reviewVisible = false;
            _this.handleSearchList();
          }).catch(function (err) {
            _this.$modal.closeLoading();
            _this.$message.error(err.message || '审核失败');
          });
        } else {
          return false;
        }
      });
    },
    checkPermi: checkPermi,
    //直接退款
    onDirectRefund: function onDirectRefund(row) {
      this.orderNo = row.orderNo;
      this.type = row.type;
      this.dialogVisibleDirectRefund = true;
    },
    //直接退款关闭
    handlerSuccessClose: function handlerSuccessClose() {
      this.dialogVisibleDirectRefund = false;
    },
    //直接退款成功回调
    handlerSuccessSubmit: function handlerSuccessSubmit() {
      this.dialogVisibleDirectRefund = false;
      this.getList();
    },
    // 核销订单
    onWriteOff: function onWriteOff(row) {
      var _this2 = this;
      this.$modalPrompt('text', '核销订单', null, '核销码').then(function (V) {
        writeUpdateApi({
          verifyCode: V
        }).then(function () {
          _this2.$message.success('核销成功');
          _this2.handleSearchList();
        });
      });
    },
    handleReset: function handleReset() {
      this.tableFrom.type = '';
      this.tableFrom.dateLimit = '';
      this.tableFrom.orderNo = '';
      this.tableFrom.page = 1;
      this.tableFrom.content = '';
      this.tableFrom.searchType = 'all';
      this.selectChange();
    },
    resetFormRefundhandler: function resetFormRefundhandler() {
      this.refundVisible = false;
    },
    resetFormRefusehand: function resetFormRefusehand() {
      this.RefuseVisible = false;
    },
    resetForm: function resetForm(formValue) {
      this.dialogVisible = false;
    },
    handleSearchList: function handleSearchList() {
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
    },
    // 发送
    sendOrder: function sendOrder(row) {
      var _this3 = this;
      if (row.isLogoff) {
        this.$modalSure('当前用户已注销，有责发货！').then(function () {
          _this3.onSend(row);
        });
      } else {
        if (row.refundStatus == 1) return this.$message.error('请先处理售后，再进行发货/核销操作');
        this.onSend(row);
      }
    },
    handlePrintReceipt: function handlePrintReceipt(row) {
      var _this4 = this;
      this.$modalSure('确认打印小票').then(function () {
        orderPrintReceiptApi(row.orderNo).then(function (data) {
          _this4.$message.success('小票打印成功');
        });
      });
    },
    //发货操作
    onSend: function onSend(row) {
      this.secondType = row.secondType;
      this.orderNo = row.orderNo;
      this.$refs.send.modals = true;
      //this.$refs.send.getList();
      this.$refs.send.orderProDetail(row.orderNo);
    },
    // 订单删除
    handleDelete: function handleDelete(row, idx) {
      var _this5 = this;
      if (row.isDel) {
        this.$modalSure().then(function () {
          orderDeleteApi({
            orderNo: row.orderNo
          }).then(function () {
            _this5.$message.success('删除成功');
            handleDeleteTable(_this5.tableData.data.length, _this5.tableFrom);
            _this5.getList();
            _this5.getOrderStatusNum();
          });
        });
      } else {
        this.$confirm('您选择的的订单存在用户未删除的订单，无法删除用户未删除的订单！', '提示', {
          confirmButtonText: '确定',
          type: 'error'
        });
      }
    },
    // 详情
    onOrderDetails: function onOrderDetails(id, tabName) {
      this.orderNo = id;
      this.$refs.orderDetail.getDetail(id, tabName);
      this.$refs.orderDetail.getOrderInvoiceList(id);
      this.$refs.orderDetail.dialogVisible = true;
    },
    getDetail: function getDetail(id) {
      var _this6 = this;
      this.loading = true;
      orderDetailApi(id).then(function (res) {
        _this6.orderDatalist = res;
        _this6.loading = false;
      }).catch(function () {
        _this6.orderDatalist = null;
        _this6.loading = false;
      });
    },
    // 订单记录
    onOrderLog: function onOrderLog(id) {
      var _this7 = this;
      this.dialogVisibleJI = true;
      this.LogLoading = true;
      this.tableFromLog.orderNo = id;
      orderLogApi(this.tableFromLog).then(function (res) {
        _this7.tableDataLog.data = res.list;
        _this7.tableDataLog.total = res.total;
        _this7.LogLoading = false;
      }).catch(function () {
        _this7.LogLoading = false;
      });
    },
    pageChangeLog: function pageChangeLog(page) {
      this.tableFromLog.page = page;
      this.onOrderLog();
    },
    handleSizeChangeLog: function handleSizeChangeLog(val) {
      this.tableFromLog.limit = val;
      this.onOrderLog();
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    // 备注
    onOrderMark: function onOrderMark(row) {
      var _this8 = this;
      this.$modalPrompt('textarea', '备注', row.merchantRemark, '订单备注').then(function (V) {
        orderMarkApi({
          remark: V,
          orderNo: row.orderNo
        }).then(function () {
          _this8.$message.success('操作成功');
          _this8.getList();
        });
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectionList = val;
      var data = [];
      this.selectionList.map(function (item) {
        data.push(item.orderNo);
      });
      this.ids = data.join(',');
    },
    // 选择时间
    selectChange: function selectChange(tab) {
      this.timeVal = [];
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
    },
    // 列表
    getList: function getList() {
      var _this9 = this;
      this.listLoading = true;
      orderListApi(this.tableFrom).then(function (res) {
        _this9.tableData.data = res.list || [];
        _this9.tableData.total = res.total;
        _this9.listLoading = false;
        _this9.checkedCities = _this9.$cache.local.has('order_stroge') ? _this9.$cache.local.getJSON('order_stroge') : _this9.checkedCities;
        // 兼容旧缓存：将"物流单号"替换为"物流信息"
        if (_this9.checkedCities.includes('物流单号')) {
          _this9.checkedCities = _this9.checkedCities.map(function (item) {
            return item === '物流单号' ? '物流信息' : item;
          });
          _this9.$cache.local.setJSON('order_stroge', _this9.checkedCities);
        }
      }).catch(function () {
        _this9.listLoading = false;
      });
    },
    // 获取各状态数量
    getOrderStatusNum: function getOrderStatusNum() {
      var _this0 = this;
      var data = Object.assign({}, this.tableFrom);
      delete data.page;
      delete data.limit;
      delete data.status;
      orderStatusNumApi(data).then(function (res) {
        _this0.orderChartType = res;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    exports: function exports() {
      var data = {
        dateLimit: this.tableFrom.dateLimit,
        orderNo: this.tableFrom.orderNo,
        status: this.tableFrom.status,
        type: this.tableFrom.type
      };
      orderExcelApi(data).then(function (res) {
        window.open(res.fileName);
      });
    },
    handleAddItem: function handleAddItem() {
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    checkSave: function checkSave() {
      this.$set(this, 'card_select_show', false);
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('order_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    },
    //打印小票
    onOrderPrint: function onOrderPrint(data) {
      var _this1 = this;
      orderPrint(data.orderNo).then(function (res) {
        _this1.$modal.msgSuccess('打印成功');
      }).catch(function (error) {
        _this1.$modal.msgError(error.message);
      });
    }
  }
};